/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum AuthenticatorHref {
    Android = 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2',
    IOS = 'https://apps.apple.com/app/google-authenticator/id388497605',
}
